import { render, staticRenderFns } from "./pg_privacy.vue?vue&type=template&id=423afe78"
import script from "./pg_privacy.vue?vue&type=script&lang=js"
export * from "./pg_privacy.vue?vue&type=script&lang=js"
import style0 from "./pg_privacy.vue?vue&type=style&index=0&id=423afe78&prod&lang=less"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports